import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import Link from 'components/link';
import Row, { Col } from 'components/row';
import Container from 'components/container';
import Icon, { iconTypes } from 'components/icon';
import CollapseLines from 'components/clamp-lines';

import img1 from './assets/image_1.jpeg';
import img2 from './assets/image_2.jpeg';
import img3 from './assets/image_3.png';
import img3p from './assets/image_3p.png';
import img4 from './assets/image_4.jpeg';

import img1br from './assets/br_image_1.png';
import img2br from './assets/br_image_2.png';
import img3br from './assets/br_image_4.png';
import img4br from './assets/br_image_6.png';

import img1vsh from './assets/vsh_image_1.png';
import img2vsh from './assets/vsh_image_2.png';
import img3vsh from './assets/vsh_image_3.png';

import img1ir from './assets/ir_image_1.png';
import img2ir from './assets/ir_image_2.png';
import img3ir from './assets/ir_image_3.png';
import img4ir from './assets/ir_image_4.png';
import img5ir from './assets/ir_image_5.png';

import translates from './statistic-seo-i18n';

import 'styles/bild/blocks/static/_statistic-seo.scss';

const bemClasses = new Bem('seoBlock');

@I18nHoc(translates())
export default class StatisticSeo extends Component {
  static propTypes = {
    className: PropTypes.string,
    params: PropTypes.shape({
      var1: PropTypes.string
    })
  };

  constructor(props, ctx) {
    super(props, ctx);

    this.renderContentKiev = this.renderContentKiev.bind(this);
    this.renderContentBrovary = this.renderContentBrovary.bind(this);
    this.renderContentVyshgorod = this.renderContentVyshgorod.bind(this);
    this.renderContentIrpen = this.renderContentIrpen.bind(this);

    this.cities = {
      'kiev': this.renderContentKiev,
      'brovary': this.renderContentBrovary,
      'vyshgorod': this.renderContentVyshgorod,
      'irpen': this.renderContentIrpen
    };
  }

  renderTableRow(col_1, col_2, col_3 = null) {
    return (
      <tr {...bemClasses('tableRow')}>
        <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={col_1} /></td>
        <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={col_2} /></td>
        {col_3 && <td {...bemClasses('tableCol')}><span {...bemClasses('text')} children={col_3} /></td>}
      </tr>
    );
  }

  renderTableRowWithLink(col_1, col_2, col_3 = null) {
    return (
      <tr {...bemClasses('tableRow')}>
        <td {...bemClasses('tableCol')} children={col_1} />
        <td {...bemClasses('tableCol')} children={col_2} />
        {col_3 && <td {...bemClasses('tableCol')} children={col_3} />}
      </tr>
    );
  }

  renderListItem(numeral, text) {
    return (
      <li>
        <span children={numeral} />
        <p children={text} />
      </li>
    );
  }

  renderLink(href, text) {
    return (
      <Link
        {...bemClasses('link')}
        href={href}
        title={text}
        external
        blank
      >
        <span {...bemClasses('text', 'link')} children={text} />
      </Link>
    );
  }

  renderContentKiev() {
    const { i18n } = this;
    const priceBeginText = i18n('priceBeginText');

    return (
      <CollapseLines
        {...bemClasses('collapse')}
        otherProps={{
          btnProps: { iconSecondType: '' }
        }}
        linesConfig={{
          desktop: 52,
          tablet: 52,
          phone: 52
        }}
      >
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block1H2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block1Text1')} />
                  <p children={i18n('block1Text2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block2H3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block2ImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img1} alt={i18n('block2ImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('block2ImgLegend1')} />
                    <div {...bemClasses('text', 'black')} children={i18n('block2ImgLegend2')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('block2TableHead1'), i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block2TableBodyR1C1'), '340', '100')}
                      {this.renderTableRow(i18n('underConstruction'), '293', '86,2')}
                      {this.renderTableRow(i18n('block2TableBodyR3C1'), '47', '13,8')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block2Text1')} />
                  <p children={i18n('block2Text2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block3H3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow('', i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block3TableBodyR1C1'), '293', '100')}
                      {this.renderTableRow(i18n('block3TableBodyR2C1'), '147', '50,2')}
                      {this.renderTableRow(i18n('block3TableBodyR3C1'), '146', '49,8')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3Text1')} />
                  <p children={i18n('block3Text2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block3ImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img2} alt={i18n('block3ImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('block3ImgLegend1')} />
                    <div {...bemClasses('text', 'red')} children={i18n('block3ImgLegend2')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block4H3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img diagram')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block4ImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={img3p} />
                      <img {...bemClasses('img')} src={img3} alt={i18n('block4ImgTopic')} loading="lazy" decoding="async" />
                    </picture>
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('block4ImgLegend1')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('block4ImgLegend2')} />
                    <div {...bemClasses('text', 'red')} children={i18n('moreThan2years')} />
                    <div {...bemClasses('text', 'black')} children={i18n('moreThan4years')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'delaysInLC')}>
                    <thead>
                      {this.renderTableRow(i18n('block4TableHead1'), i18n('amountLC'), i18n('block4TableHead3', { placeholder: 146 }))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block4TableBodyR1C1'), '146', '100')}
                      {this.renderTableRow(i18n('block4TableBodyR2C1'), '37', '25,3')}
                      {this.renderTableRow(i18n('moreYear'), '35', '24,0')}
                      {this.renderTableRow(i18n('moreThan2years'), '32', '21,9')}
                      {this.renderTableRow(i18n('moreThan4years'), '42', '28,8')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block4Text1')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'shieldsBefore')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block5H2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block5Text1')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'shields')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('green')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5ShieldGreenText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('orange')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5ShieldOrangeText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'lowLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('red')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5ShieldRedText')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'catPayAttention')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} mtOrder={1} mpOrder={1} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block5Text2')} />
                  <p children={i18n('block5Text3')} />
                  <p children={i18n('block5Text4')} />
                  <p {...bemClasses('mb2')} children={i18n('block5Text5')} />
                  <p children={i18n('block5Text6')} />
                  <p children={i18n('block5Text7')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right comment')} allAuto allPr={0}>
                <div {...bemClasses('textContainer')}>
                  <div {...bemClasses('text')}>
                    <p children={i18n('block5Comment1')} />
                  </div>
                  <Icon {...bemClasses('icon', 'cat')} type={iconTypes.catPayAttention} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'catWhatToDo')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left comment')} mtOrder={1} mpOrder={1} allAuto allPr={0}>
                <div {...bemClasses('textContainer')}>
                  <div {...bemClasses('text')}>
                    <p children={i18n('block5Comment2')} />
                  </div>
                  <Icon {...bemClasses('icon', 'cat')} type={iconTypes.catLowFull} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img circle')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block5Text8')} />
                </div>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block5ImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img4} alt={i18n('block5ImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('shieldGreen')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('shieldOrange')} />
                    <div {...bemClasses('text', 'red')} children={i18n('shieldRed')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2')}>
              <h2 children={i18n('block6H2')} />
            </div>
            <div {...bemClasses('text', 'h2After')}>
              <p children={i18n('block6Text1')} />
            </div>
            <Row {...bemClasses('row', 'textTable')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} mtOrder={1} mpOrder={1} allAuto allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'typeApartments')}>
                    <thead>
                      {this.renderTableRow(i18n('typeApartment'), i18n('pricePerSqMHousesUnderConstruction'), i18n('pricePerSqMHousesFinished'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('smart'), '14 000 - 35 770', '30 000 - 31 150')}
                      {this.renderTableRow(i18n('studio'), '23 850 - 28 353', `${priceBeginText} 18 000`)}
                      {this.renderTableRow(i18n('roomOne'), '15 200 - 134 595', '17 500 - 108 750')}
                      {this.renderTableRow(i18n('roomTwo'), '15 200 - 184 350', '15 127 - 108 750')}
                      {this.renderTableRow(i18n('roomThree'), '15 200 - 168 243', '17 000 - 112 700')}
                      {this.renderTableRow(i18n('roomFour'), '18 000 - 75 020', '16 050 - 141 400')}
                      {this.renderTableRow(i18n('roomFiveMore'), '20 000 - 53 105', '20 000 - 111 300')}
                      {this.renderTableRow(i18n('tierTwo'), '17 800 - 69 000', '17 004 - 113 800')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text', 'h3')}>
                  <h3 children={i18n('block6H3')} />
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block6Text2')} />
                  <p {...bemClasses('mb2')} children={i18n('block6Text3')} />
                  <p children={i18n('block6Text4')} />
                  <p children={i18n('block6Text5')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'textTable')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} allPr={0}>
                <div {...bemClasses('text', 'h3')}>
                  <h3 children={i18n('block7H3')} />
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block7Text1')} />
                  <p {...bemClasses('mb2')} children={i18n('block7Text2')} />
                  <p children={i18n('block7Text3')} />
                  <p children={i18n('block7Text4')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allAuto allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'district')}>
                    <thead>
                      {this.renderTableRow(i18n('block7TableHead1'), i18n('block7TableHead2'), i18n('block7TableHead3'))}
                    </thead>
                    <tbody>
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR1C1url'), i18n('block7TableBodyR1C1')),
                        <span {...bemClasses('text')} children="16 200 - 84 300" />,
                        <span {...bemClasses('text')} children="15 127 - 91 050" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR2C1url'), i18n('block7TableBodyR2C1')),
                        <span {...bemClasses('text')} children="15 200 - 33 000" />,
                        <span {...bemClasses('text')} children="19 584 - 42 400" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR3C1url'), i18n('block7TableBodyR3C1')),
                        <span {...bemClasses('text')} children="17 500 - 43 000" />,
                        <span {...bemClasses('text')} children="22 000 - 49 613" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR4C1url'), i18n('block7TableBodyR4C1')),
                        <span {...bemClasses('text')} children="30 974 - 189 500" />,
                        <span {...bemClasses('text')} children="38 200 - 141 400" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR5C1url'), i18n('block7TableBodyR5C1')),
                        <span {...bemClasses('text')} children="17 740 - 129 300" />,
                        <span {...bemClasses('text')} children="17 004 - 52 000" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR6C1url'), i18n('block7TableBodyR6C1')),
                        <span {...bemClasses('text')} children="19 500 - 65 700" />,
                        <span {...bemClasses('text')} children="17 500 - 94 500" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR7C1url'), i18n('block7TableBodyR7C1')),
                        <span {...bemClasses('text')} children="24 000 - 63 450" />,
                        <span {...bemClasses('text')} children="22 800 - 70 750" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR8C1url'), i18n('block7TableBodyR8C1')),
                        <span {...bemClasses('text')} children="19 225 - 41 650" />,
                        <span {...bemClasses('text')} children="16 300 - 32 900" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR9C1url'), i18n('block7TableBodyR9C1')),
                        <span {...bemClasses('text')} children="16 100 - 80 900" />,
                        <span {...bemClasses('text')} children="19 900 - 40 600" />
                      )}
                      {this.renderTableRowWithLink(
                        this.renderLink(i18n('block7TableBodyR10C1url'), i18n('block7TableBodyR10C1')),
                        <span {...bemClasses('text')} children="17 000 - 31 128" />,
                        <span {...bemClasses('text')} children="16 050 - 44 751" />
                      )}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'comment')} mpColumn>
              <Col {...bemClasses('col', 'left icon')} allPr={0}>
                <Icon {...bemClasses('icon', 'cat')} type={iconTypes.catNAFull} />
              </Col>
              <Col {...bemClasses('col', 'right comment')} allPr={0}>
                <div {...bemClasses('textContainer')}>
                  <div {...bemClasses('text')}>
                    <p children={i18n('block7Comment')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('arrangementResidentialComplexes')} />
            </div>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('repairs'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('withoutFinishing'), '148')}
                      {this.renderTableRow(i18n('forFinishing'), '51')}
                      {this.renderTableRow(i18n('renovatedFromDeveloper'), '25')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('heating'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('centralized'), '138')}
                      {this.renderTableRow(i18n('autonomousBoilerRoom'), '92')}
                      {this.renderTableRow(i18n('individual'), '56')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('concept'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('yardWithoutCars'), '82')}
                      {this.renderTableRow(i18n('cityWithinCity'), '34')}
                      {this.renderTableRow(i18n('atWater'), '24')}
                      {this.renderTableRow(i18n('operatedRoof'), '32')}
                      {this.renderTableRow(i18n('pantriesInHouse'), '13')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('infrastructureParkingSecurity'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('parkingUnderground'), '194')}
                      {this.renderTableRow(i18n('garageBoxes'), '5')}
                      {this.renderTableRow(i18n('closedArea'), '159')}
                      {this.renderTableRow(i18n('parkOnTerritory'), '19')}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row')}>
              <Col {...bemClasses('col', 'text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block8Text1')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block9H3')} />
            </div>
            <div {...bemClasses('list', 'withImg')}>
              <ul>
                {this.renderListItem(575, i18n('block9ListItem1'))}
                {this.renderListItem(492,i18n('block9ListItem2'))}
                {this.renderListItem(76,i18n('block9ListItem3'))}
                {this.renderListItem(24,i18n('block9ListItem4'))}
                {this.renderListItem(19,i18n('block9ListItem5'))}
                {this.renderListItem(457,i18n('block9ListItem6'))}
              </ul>
            </div>
            <Row {...bemClasses('row', 'texts')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block9Text1')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block9Text2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2 total')}>
              <h2 children={i18n('result')} />
            </div>
            <Row {...bemClasses('row', 'total')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'list')} allPr={0}>
                <div {...bemClasses('list', 'withNumeric')}>
                  <ol>
                    <li><p children={i18n('block10ListItem1')} /></li>
                    <li><p children={i18n('block10ListItem2')} /></li>
                    <li><p children={i18n('block10ListItem3')} /></li>
                    <li><p children={i18n('block10ListItem4')} /></li>
                    <li><p children={i18n('block10ListItem5')} /></li>
                    <li><p children={i18n('block10ListItem6')} /></li>
                    <li><p children={i18n('block10ListItem7')} /></li>
                  </ol>
                </div>
              </Col>
              <Col {...bemClasses('col', 'info')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block10List2Topic')} />
                </div>
                <table {...bemClasses('tableList')}>
                  <tbody>
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block10List2Item1url'), i18n('block10List2Item1')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="212" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block10List2Item2url'), i18n('block10List2Item2')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="209" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block10List2Item3url'), i18n('block10List2Item3')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="208" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block10List2Item4url'), i18n('block10List2Item4')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="208" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block10List2Item5url'), i18n('block10List2Item5')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="208" />
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </div>
      </CollapseLines>
    );
  }

  renderContentBrovary() {
    const { i18n } = this;

    return (
      <CollapseLines
        {...bemClasses('collapse')}
        otherProps={{
          btnProps: { iconSecondType: '' }
        }}
        linesConfig={{
          desktop: 84,
          tablet: 84,
          phone: 84
        }}
      >
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block1BrH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block1BrText1')} />
                </div>
                <div {...bemClasses('list', 'withBullet')}>
                  <ul>
                    <li><p children={i18n('block1BrListItem1')} /></li>
                    <li><p children={i18n('block1BrListItem2')} /></li>
                    <li><p children={i18n('block1BrListItem3')} /></li>
                    <li><p children={i18n('block1BrListItem4')} /></li>
                    <li><p children={i18n('block1BrListItem5')} /></li>
                    <li><p children={i18n('block1BrListItem6')} /></li>
                    <li><p children={i18n('block1BrListItem7')} /></li>
                    <li><p children={i18n('block1BrListItem8')} /></li>
                  </ul>
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mt2')} children={i18n('block1BrText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block2BrH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block2BrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img1br} alt={i18n('block2BrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'orange')} children={i18n('block2BrImgLegend1')} />
                    <div {...bemClasses('text', 'black')} children={i18n('block2BrImgLegend2')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block2BrText1')} />
                  <p children={i18n('block2BrText2')} />
                  <p children={i18n('block2BrText3')} />
                  <p {...bemClasses('mb2')} children={i18n('block2BrText4')} />
                  <p children={i18n('block2BrText5')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'shieldsBefore')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block3BrH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3BrText1')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'shields')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('green')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3BrShieldGreenText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('orange')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3BrShieldOrangeText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'lowLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('red')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3BrShieldRedText')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} mtOrder={1} mpOrder={1} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3BrText2')} />
                  <p {...bemClasses('mb2')} children={i18n('block3BrText3')} />
                  <p children={i18n('block3BrText4')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block3ИкImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img2br} alt={i18n('block3ИкImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('block3BrImgLegend1')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('block3BrImgLegend2')} />
                    <div {...bemClasses('text', 'red')} children={i18n('block3BrImgLegend3')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block4BrH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block4BrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img3br} alt={i18n('block4BrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('block4BrImgLegend1')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('block4BrImgLegend2')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('block4BrImgLegend3')} />
                    <div {...bemClasses('text', 'red')} children={i18n('block4BrMoreThan2years')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block4BrText1')} />
                  <p children={i18n('block4BrText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'textTable')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} mtOrder={1} mpOrder={1} allAuto allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'typeApartments')}>
                    <thead>
                      {this.renderTableRow(i18n('typeApartment'), i18n('pricePerSqMHousesUnderConstruction'), i18n('pricePerSqMHousesFinished'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('smart'), '-', '-')}
                      {this.renderTableRow(i18n('studio'), '16 000', '16 000')}
                      {this.renderTableRow(i18n('roomOne'), '14 600 - 21 960', '15 800 - 20 000')}
                      {this.renderTableRow(i18n('roomTwo'), '14 600 - 22 000', '15 000 - 20 564')}
                      {this.renderTableRow(i18n('roomThree'), '14 000 - 20 383', '14 000 - 18 720')}
                      {this.renderTableRow(i18n('roomFour'), '17 000 - 20 000', '17 000 - 20 000')}
                      {this.renderTableRow(i18n('roomFiveMore'), '-', '21 000')}
                      {this.renderTableRow(i18n('tierTwo'), '14 000 - 21 107', '16 200 - 18 000')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text', 'h3')}>
                  <h3 children={i18n('block5BrH3')} />
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block5BrText1')} />
                  <p children={i18n('block5BrText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2')}>
              <h2 children={i18n('block6BrH2')} />
            </div>
            <div {...bemClasses('text', 'h2After')}>
              <p children={i18n('block6BrH2After')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block6BrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img4br} alt={i18n('block6BrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('classEconomy')} />
                    <div {...bemClasses('text', 'green')} children={i18n('classComfort')} />
                    <div {...bemClasses('text', 'blue')} children={i18n('classBusiness')} />
                    <div {...bemClasses('text', 'pink')} children={i18n('classPremium')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('totalLCDforSale'), '16', '100')}
                      {this.renderTableRow(i18n('ofThem'), ' ', ' ')}
                      {this.renderTableRow(i18n('classEconomy'), '4', '25,0')}
                      {this.renderTableRow(i18n('classComfort'), '7', '43,8')}
                      {this.renderTableRow(i18n('classBusiness'), '4', '25,0')}
                      {this.renderTableRow(i18n('classPremium'), '1', '6,3')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block6BrText1')} />
                  <p children={i18n('block6BrText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block7BrH3')} />
            </div>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('repairs'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('withoutFinishingOrRough'), '10')}
                      {this.renderTableRow(i18n('forFinishing'), '4')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('heating'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('centralized'), '7')}
                      {this.renderTableRow(i18n('autonomousBoilerRoom'), '5')}
                      {this.renderTableRow(i18n('individual'), '4')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('concept'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('yardWithoutCars'), '0')}
                      {this.renderTableRow(i18n('cityWithinCity'), '6')}
                      {this.renderTableRow(i18n('atWater'), '1')}
                      {this.renderTableRow(i18n('operatedRoof'), '0')}
                      {this.renderTableRow(i18n('areasRecreationOnSite'), '8')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('infrastructureParkingSecurity'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block7BrTable4BodyR1C1'), '5')}
                      {this.renderTableRow(i18n('garageBoxes'), '0')}
                      {this.renderTableRow(i18n('closedArea'), '8')}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2 total')}>
              <h2 children={i18n('result')} />
            </div>
            <Row {...bemClasses('row', 'total')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'list')} allPr={0}>
                <div {...bemClasses('list', 'withNumeric')}>
                  <ol>
                    <li><p children={i18n('block8BrListItem1')} /></li>
                    <li><p children={i18n('block8BrListItem2')} /></li>
                    <li><p children={i18n('block8BrListItem3')} /></li>
                    <li><p children={i18n('block8BrListItem4')} /></li>
                    <li><p children={i18n('block8BrListItem5')} /></li>
                    <li><p children={i18n('block8BrListItem6')} /></li>
                    <li><p children={i18n('block8BrListItem7')} /></li>
                    <li><p children={i18n('block8BrListItem8')} /></li>
                  </ol>
                </div>
              </Col>
              <Col {...bemClasses('col', 'info')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block8BrList2Topic')} />
                </div>
                <table {...bemClasses('tableList')}>
                  <tbody>
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block8BrList2Item1url'), i18n('block8BrList2Item1')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="203" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block8BrList2Item2url'), i18n('block8BrList2Item2')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="203" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block8BrList2Item3url'), i18n('block8BrList2Item3')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="199" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block8BrList2Item4url'), i18n('block8BrList2Item4')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="199" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block8BrList2Item5url'), i18n('block8BrList2Item5')),
                      <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="198" />
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </div>
      </CollapseLines>
    );
  }

  renderContentVyshgorod() {
    const { i18n } = this;

    return (
      <CollapseLines
        {...bemClasses('collapse')}
        otherProps={{
          btnProps: { iconSecondType: '' }
        }}
        linesConfig={{
          desktop: 70,
          tablet: 70,
          phone: 70
        }}
      >
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block1VshH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block1VshText1')} />
                </div>
                <div {...bemClasses('list', 'simply')}>
                  <ul>
                    <li><p children={i18n('block1VshListItem1')} /></li>
                    <li><p children={i18n('block1VshListItem2')} /></li>
                    <li><p children={i18n('block1VshListItem3')} /></li>
                    <li><p children={i18n('block1VshListItem4')} /></li>
                    <li><p children={i18n('block1VshListItem5')} /></li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block2VshH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block2VshImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img1vsh} alt={i18n('block2VshImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('block2VshImgLegend1')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('block2VshImgLegend2')} />
                    <div {...bemClasses('text', 'grey')} children={i18n('block2VshImgLegend3')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block2VshText1')} />
                  <p children={i18n('block2VshText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'shieldsBefore')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block3VshH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3VshText1')} />
                  <p children={i18n('block3VshText2')} />
                  <p {...bemClasses('mt2')} children={i18n('block3VshText3')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'shields')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('green')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3VshShieldGreenText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('orange')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3VshShieldOrangeText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'lowLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('red')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block3VshShieldRedText')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'catPayAttention')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} mtOrder={1} mpOrder={1} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3VshText4')} />
                  <p children={i18n('block3VshText5')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right comment')} allAuto allPr={0}>
                <div {...bemClasses('textContainer')}>
                  <div {...bemClasses('text')}>
                    <p children={i18n('block3VshComment1')} />
                  </div>
                  <Icon {...bemClasses('icon', 'cat')} type={iconTypes.catPayAttention} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left text')} mtOrder={1} mpOrder={1} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block3VshText6')} />
                  <p children={i18n('block3VshText7')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block3VshImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img2vsh} alt={i18n('block3VshImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('shieldGreen')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('shieldOrange')} />
                    <div {...bemClasses('text', 'red')} children={i18n('shieldRed')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block4VshH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block4VshText1')} />
                  <p {...bemClasses('mb2')} children={i18n('block4VshText2')} />
                  <p children={i18n('block4VshText3')} />
                  <p children={i18n('block4VshText4')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block4VshImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img3vsh} alt={i18n('block4VshImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('block4VshImgLegend1')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('moreYear')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('block4VshImgLegend3')} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block5VshH3')} />
            </div>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block5VshText1')} />
                </div>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'typeApartments')}>
                    <thead>
                      {this.renderTableRow(i18n('typeApartment'), i18n('pricePerSqMHousesUnderConstruction'), i18n('pricePerSqMHousesFinished'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('smart'), '-', '-')}
                      {this.renderTableRow(i18n('studio'), '-', '-')}
                      {this.renderTableRow(i18n('roomOne'), '15 500 - 23 150', '18 600')}
                      {this.renderTableRow(i18n('roomTwo'), '15 050 - 22 150', '18 150')}
                      {this.renderTableRow(i18n('roomThree'), '15 350 - 22 650', '16 650')}
                      {this.renderTableRow(i18n('roomFour'), '-', '-')}
                      {this.renderTableRow(i18n('roomFiveMore'), '-', '-')}
                      {this.renderTableRow(i18n('tierTwo'), '16 650 - 18 000', '13 400 - 16 650')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block5VshText2')} />
                </div>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('totalLCDforSale'), '10', '100')}
                      {this.renderTableRow(i18n('ofThem'), ' ', ' ')}
                      {this.renderTableRow(i18n('classEconomy'), '3', '30')}
                      {this.renderTableRow(i18n('classComfort'), '5', '50')}
                      {this.renderTableRow(i18n('classBusiness'), '2', '20')}
                      {this.renderTableRow(i18n('classPremium'), '-', '-')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block5VshText3')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block6VshH3')} />
            </div>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('repairs'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('withoutFinishingOrRough'), '5')}
                      {this.renderTableRow(i18n('forFinishing'), '4')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('heating'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('centralized'), '3')}
                      {this.renderTableRow(i18n('autonomousBoilerRoom'), '6')}
                      {this.renderTableRow(i18n('individual'), '3')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('concept'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('yardWithoutCars'), '0')}
                      {this.renderTableRow(i18n('cityWithinCity'), '0')}
                      {this.renderTableRow(i18n('atWater'), '2')}
                      {this.renderTableRow(i18n('operatedRoof'), '1')}
                      {this.renderTableRow(i18n('areasRecreationOnSite'), '6')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('infrastructureParkingSecurity'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('parkingUnderground'), '2')}
                      {this.renderTableRow(i18n('garageBoxes'), '0')}
                      {this.renderTableRow(i18n('closedArea'), '5')}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row')}>
              <Col {...bemClasses('col', 'text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block6VshText1')} />
                  <p children={i18n('block6VshText2')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2 total')}>
              <h2 children={i18n('result')} />
            </div>
            <Row {...bemClasses('row', 'total')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'list')} allPr={0}>
                <div {...bemClasses('list', 'withNumeric')}>
                  <ol>
                    <li><p children={i18n('block7VshListItem1')} /></li>
                    <li><p children={i18n('block7VshListItem2')} /></li>
                    <li><p children={i18n('block7VshListItem3')} /></li>
                    <li><p children={i18n('block7VshListItem4')} /></li>
                    <li><p children={i18n('block7VshListItem5')} /></li>
                    <li><p children={i18n('block7VshListItem6')} /></li>
                    <li><p children={i18n('block7VshListItem7')} /></li>
                    <li><p children={i18n('block7VshListItem8')} /></li>
                  </ol>
                </div>
              </Col>
              <Col {...bemClasses('col', 'info')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block7VshList2Topic')} />
                </div>
                <table {...bemClasses('tableList')}>
                  <tbody>
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block7VshList2Item1url'), i18n('block7VshList2Item1')),
                      <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="192" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block7VshList2Item2url'), i18n('block7VshList2Item2')),
                      <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="179" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block7VshList2Item3url'), i18n('block7VshList2Item3')),
                      <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="178" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block7VshList2Item4url'), i18n('block7VshList2Item4')),
                      <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="177" />
                    )}
                    {this.renderTableRowWithLink(
                      this.renderLink(i18n('block7VshList2Item5url'), i18n('block7VshList2Item5')),
                      <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />,
                      <span {...bemClasses('text')} children="177" />
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </div>
      </CollapseLines>
    );
  }

  renderContentIrpen() {
    const { i18n } = this;

    return (
      <CollapseLines
        {...bemClasses('collapse')}
        otherProps={{
          btnProps: { iconSecondType: '' }
        }}
        linesConfig={{
          desktop: 84,
          tablet: 84,
          phone: 84
        }}
      >
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block1IrH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block1IrText1')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mt2')} children={i18n('block1IrText2')} />
                  <p children={i18n('block1IrText3')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mt2')} children={i18n('block1IrText4')} />
                  <p {...bemClasses('mt2')} children={i18n('block1IrText5')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block2IrhH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block2IrhText1')} />
                </div>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('totalLCDwithApartments'), '65', '100')}
                      {this.renderTableRow(i18n('ofThem'), ' ', ' ')}
                      {this.renderTableRow(i18n('handedOver'), '18', '27,7')}
                      {this.renderTableRow(i18n('underConstruction'), '47', '72,3')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block2IrhText2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block2IrhImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img1ir} alt={i18n('block2IrhImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'blue')} children={i18n('handedOver')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('underConstruction')} />
                  </div>
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mt2')} children={i18n('block2IrhText3')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block3IrH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block3IrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img2ir} alt={i18n('block3IrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'red')} children={i18n('block3IrImgLegend1')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('block3IrImgLegend2')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block3IrTableBodyR1C1'), '47', '100')}
                      {this.renderTableRow(i18n('ofThem'), ' ', ' ')}
                      {this.renderTableRow(i18n('block3IrImgLegend1'), '30', '63,8')}
                      {this.renderTableRow(i18n('block3IrImgLegend2'), '17', '36,2')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block3IrText1')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block4IrH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block4IrText1')} />
                </div>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('block4IrTableBodyR1C1'), '30', '100')}
                      {this.renderTableRow(i18n('block4IrTableBodyR2C1'), ' ', ' ')}
                      {this.renderTableRow(i18n('block4IrToYear'), '14', '46,6')}
                      {this.renderTableRow(i18n('moreYear'), '8', '26,7')}
                      {this.renderTableRow(i18n('moreThan2years'), '7', '23,3')}
                      {this.renderTableRow(i18n('moreThan4years'), '1', '3,3')}
                    </tbody>
                  </table>
                </div>
                <div {...bemClasses('text')}>
                  <p children={i18n('block4IrText2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block4IrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img3ir} alt={i18n('block4IrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('block4IrToYear')} />
                    <div {...bemClasses('text', 'orange')} children={i18n('moreYear')} />
                    <div {...bemClasses('text', 'red')} children={i18n('moreThan2years')} />
                    <div {...bemClasses('text', 'black')} children={i18n('moreThan4years')} />
                  </div>
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mt2')} children={i18n('block4IrText3')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <Row {...bemClasses('row', 'shieldsBefore')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left topic')} allPr={0}>
                <div {...bemClasses('text', 'h2')}>
                  <h2 children={i18n('block5IrH2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block5IrText1')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row', 'shields')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('green')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5IrShieldGreenText')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'mediumLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('orange')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5IrShieldOrangeText1')} />
                  <p children={i18n('block5IrShieldOrangeText2')} />
                </div>
              </Col>
              <Col {...bemClasses('col', 'shield')} allFlex allPr={0}>
                <Icon {...bemClasses('icon', 'lowLevel')} type={iconTypes.bc} />
                <span {...bemClasses('text', 'forIcon')} children={i18n('red')} />
                <div {...bemClasses('text')}>
                  <p children={i18n('block5IrShieldRedText')} />
                </div>
              </Col>
            </Row>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block5IrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img4ir} alt={i18n('block5IrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'green')} children={i18n('shieldGreen')} />
                    <div {...bemClasses('text', 'yellow')} children={i18n('shieldOrange')} />
                    <div {...bemClasses('text', 'red')} children={i18n('shieldRed')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allFlex allColumn allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block5IrText2')} />
                  <p children={i18n('block5IrText3')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2')}>
              <h2 children={i18n('block6IrH2')} />
            </div>
            <div {...bemClasses('text', 'h2After')}>
              <p children={i18n('block6IrText1')} />
            </div>
            <Row {...bemClasses('row', 'textTable')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} mtOrder={1} mpOrder={1} allAuto allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table', 'typeApartments')}>
                    <thead>
                      {this.renderTableRow(i18n('typeApartment'), i18n('pricePerSqMHousesUnderConstruction'), i18n('pricePerSqMHousesFinished'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('smart'), '-', '-')}
                      {this.renderTableRow(i18n('studio'), '-', '20 100')}
                      {this.renderTableRow(i18n('roomOne'), '13 500 - 26 700', '26 700')}
                      {this.renderTableRow(i18n('roomTwo'), '13 500 - 23 850', '12 800 - 23 850')}
                      {this.renderTableRow(i18n('roomThree'), '14 000 - 23 850', '14 200 - 23 850')}
                      {this.renderTableRow(i18n('roomFour'), '17 100 - 22 500', '18 300')}
                      {this.renderTableRow(i18n('roomFiveMore'), '-', '18 300')}
                      {this.renderTableRow(i18n('tierTwo'), '14 000 - 23 000', '23 850')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right text')} allPr={0}>
                <div {...bemClasses('text', 'h3')}>
                  <h3 children={i18n('block6IrH3')} />
                </div>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block6IrText2')} />
                  <p children={i18n('block6IrText3')} />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('block7IrH3')} />
            </div>
            <Row {...bemClasses('row')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left img')} allPr={0}>
                <div {...bemClasses('picture')}>
                  <div {...bemClasses('imgTopic')}>
                    <span {...bemClasses('text')} children={i18n('block7IrImgTopic')} />
                  </div>
                  <div {...bemClasses('imgContainer')}>
                    <img {...bemClasses('img')} src={img5ir} alt={i18n('block7IrImgTopic')} loading="lazy" decoding="async" />
                  </div>
                  <div {...bemClasses('imgLegend')}>
                    <div {...bemClasses('text', 'yellow')} children={i18n('classEconomy')} />
                    <div {...bemClasses('text', 'green')} children={i18n('classComfort')} />
                    <div {...bemClasses('text', 'blue')} children={i18n('classBusiness')} />
                    <div {...bemClasses('text', 'pink')} children={i18n('classPremium')} />
                  </div>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allFlex allColumn allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(null, i18n('amountLC'), '%')}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('totalLCDforSale'), '65', '100')}
                      {this.renderTableRow(i18n('ofThem'), ' ', ' ')}
                      {this.renderTableRow(i18n('classEconomy'), '7', '10,8')}
                      {this.renderTableRow(i18n('classComfort'), '38', '58,4')}
                      {this.renderTableRow(i18n('classBusiness'), '18', '27,7')}
                      {this.renderTableRow(i18n('classPremium'), '2', '3,1')}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block', 'white')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2')}>
              <h2 children={i18n('block8IrH2')} />
            </div>
            <div {...bemClasses('text', 'h2After')}>
              <p children={i18n('block8IrText1')} />
            </div>
            <div {...bemClasses('text', 'h3')}>
              <h3 children={i18n('arrangementResidentialComplexes')} />
            </div>
            <Row {...bemClasses('row', 'tables')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('repairs'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('withoutFinishing'), '19')}
                      {this.renderTableRow(i18n('forFinishing'), '24')}
                      {this.renderTableRow(i18n('renovatedFromDeveloper'), '6')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('heating'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('centralized'), '4')}
                      {this.renderTableRow(i18n('autonomousBoilerRoom'), '11')}
                      {this.renderTableRow(i18n('individual'), '46')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'left table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('concept'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('yardWithoutCars'), '13')}
                      {this.renderTableRow(i18n('cityWithinCity'), '7')}
                      {this.renderTableRow(i18n('atWater'), '2')}
                      {this.renderTableRow(i18n('operatedRoof'), '1')}
                      {this.renderTableRow(i18n('pantriesInHouse'), '1')}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col {...bemClasses('col', 'right table')} allPr={0}>
                <div {...bemClasses('tableContainer')}>
                  <table {...bemClasses('table')}>
                    <thead>
                      {this.renderTableRow(i18n('infrastructureParkingSecurity'), i18n('amountLC'))}
                    </thead>
                    <tbody>
                      {this.renderTableRow(i18n('parkingUnderground'), '21')}
                      {this.renderTableRow(i18n('garageBoxes'), '4')}
                      {this.renderTableRow(i18n('closedArea'), '26')}
                      {this.renderTableRow(i18n('parkOnTerritory'), '7')}
                    </tbody>
                  </table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div {...bemClasses('block')}>
          <Container {...bemClasses('content')} body>
            <div {...bemClasses('text', 'h2 total')}>
              <h2 children={i18n('result')} />
            </div>
            <Row {...bemClasses('row', 'total')} mtColumn mpColumn>
              <Col {...bemClasses('col', 'list')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p {...bemClasses('mb2')} children={i18n('block9IrText1')} />
                </div>
                <div {...bemClasses('list', 'withNumeric')}>
                  <ol>
                    <li><p children={i18n('block9IrListItem1')} /></li>
                    <li><p children={i18n('block9IrListItem2')} /></li>
                    <li><p children={i18n('block9IrListItem3')} /></li>
                    <li><p children={i18n('block9IrListItem4')} /></li>
                  </ol>
                </div>
              </Col>
              <Col {...bemClasses('col', 'info')} allPr={0}>
                <div {...bemClasses('text')}>
                  <p children={i18n('block9IrList2Topic')} />
                </div>
                <table {...bemClasses('tableList')}>
                  <tbody>
                  {this.renderTableRowWithLink(
                    this.renderLink(i18n('block9IrList2Item1url'), i18n('block9IrList2Item1')),
                    <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                    <span {...bemClasses('text')} children="201" />
                  )}
                  {this.renderTableRowWithLink(
                    this.renderLink(i18n('block9IrList2Item2url'), i18n('block9IrList2Item2')),
                    <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                    <span {...bemClasses('text')} children="204" />
                  )}
                  {this.renderTableRowWithLink(
                    this.renderLink(i18n('block9IrList2Item3url'), i18n('block9IrList2Item3')),
                    <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                    <span {...bemClasses('text')} children="196" />
                  )}
                  {this.renderTableRowWithLink(
                    this.renderLink(i18n('block9IrList2Item4url'), i18n('block9IrList2Item4')),
                    <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                    <span {...bemClasses('text')} children="194" />
                  )}
                  {this.renderTableRowWithLink(
                    this.renderLink(i18n('block9IrList2Item5url'), i18n('block9IrList2Item5')),
                    <Icon {...bemClasses('icon', 'highLevel')} type={iconTypes.bc} />,
                    <span {...bemClasses('text')} children="193" />
                  )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Container>
        </div>
      </CollapseLines>
    );
  }

  render() {
    const { className, params } = this.props;
    const var1 = get(params, 'var1');

    if (typeof get(this, `cities[${var1}]`) !== 'function') return null;

    return (
      <div {...bemClasses({ extra: className })}>
        {this.cities[var1]()}
      </div>
    );
  }
}
